import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, ShieldCheck, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export default function StaffGate({ onUnlock }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/staff/login", { pin });
      sessionStorage.setItem("cg_staff", "1");
      sessionStorage.setItem("cg_staff_pin", pin);
      setError("");
      onUnlock();
    } catch {
      setError("PIN incorrecto. Intenta nuevamente.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="staff-gate" className="min-h-[80vh] flex items-center justify-center section-pad">
      <div className="container-cg max-w-md">
        <div className="card-cg p-8 md:p-10">
          <div className="flex items-center gap-3">
            <ShieldCheck className="text-[var(--brand-primary)]" />
            <div className="overline text-[var(--brand-primary)]">Acceso restringido</div>
          </div>
          <h1 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-4">
            Portal del Staff
          </h1>
          <p className="text-sm text-[var(--brand-muted)] mt-3 leading-relaxed">
            Esta sección está reservada para el comité organizador. Ingresa el PIN para continuar.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="overline text-[var(--brand-muted)]" htmlFor="pin">PIN de acceso</label>
              <div className="relative mt-2">
                <KeyRound size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--brand-muted)]" />
                <input
                  id="pin"
                  data-testid="staff-pin-input"
                  type="password"
                  inputMode="numeric"
                  autoComplete="off"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                  placeholder="••••"
                  className="w-full pl-10 pr-4 py-3 bg-[var(--brand-surface-alt)] border border-[var(--brand-border)] focus:border-[var(--brand-primary)] outline-none tracking-[0.4em] font-serif-cg text-lg"
                />
              </div>
            </div>

            {error && (
              <div data-testid="staff-pin-error" className="flex items-center gap-2 text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2">
                <AlertTriangle size={14} />
                {error}
              </div>
            )}

            <button type="submit" disabled={submitting} data-testid="staff-pin-submit" className="btn-primary-cg w-full justify-center">
              {submitting ? "Verificando..." : "Ingresar al portal"}
            </button>

            <button
              type="button"
              onClick={() => navigate("/")}
              className="text-xs text-[var(--brand-muted)] link-underline mx-auto block"
              data-testid="staff-back-home"
            >
              Volver al sitio público
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
